import React from "react";
import "./Footer.css";
import Button from "../../../../../shared/components/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchExamQuestionRequest,
  setCurrentQuestionIndex,
  updateQuestionStatus,
  setActiveSection,
  saveAnswerRequest,
} from "../../../../../redux/exam/examSlice";

const Footer = () => {
  const dispatch = useDispatch();
  const { currentQuestionIndex, questionsData, testType, testDetails } =
    useSelector((state) => state.examSlice);

  const currentQuestion = questionsData[currentQuestionIndex];

  // Helper to get section key
  const getSectionKey = (q) => `${q.subject} ${q.section_name || ""}`.trim();

  // ✅ Handle Previous Button
  const handlePrevious = () => {
    if (currentQuestionIndex > 0) {
      const prevIndex = currentQuestionIndex - 1;
      const prevQuestion = questionsData[prevIndex];

      // dispatch(setCurrentQuestionIndex(prevIndex));
      dispatch(fetchExamQuestionRequest(prevQuestion.qid));

      // Only update section if it's different
      const prevSection = getSectionKey(prevQuestion);
      const currSection = getSectionKey(currentQuestion);
      if (prevSection !== currSection) {
        dispatch(setActiveSection(prevSection));
      }
    }
  };

  // ✅ Handle Save & Next Button
  // const handleSaveNext = () => {
  //   if (currentQuestion) {
  //     dispatch(
  //       updateQuestionStatus({
  //         qid: currentQuestion.qid,
  //         moveAway: true, // finalize current question
  //       })
  //     );
  //   }

  //   if (currentQuestionIndex < questionsData.length - 1) {
  //     const nextIndex = currentQuestionIndex + 1;
  //     const nextQuestion = questionsData[nextIndex];

  //     dispatch(setCurrentQuestionIndex(nextIndex));
  //     dispatch(fetchExamQuestionRequest(nextQuestion.qid));

  //     // Only update section if needed
  //     const nextSection = getSectionKey(nextQuestion);
  //     const currSection = getSectionKey(currentQuestion);
  //     if (nextSection !== currSection) {
  //       dispatch(setActiveSection(nextSection));
  //     }
  //   }
  // };
  const handleSaveNext = () => {
    if (currentQuestion) {
      const payload = {
        option_id: [currentQuestion.selectedOption], // as array
        paper_id: testDetails?.paper_id,
        qid: currentQuestion.qid,
        time: currentQuestion.time || 0, // track question time
        paper_type: testType?.id,
        question_status: currentQuestion.selectedOption ? 1 : 0, // 1 if answered
      };

      dispatch(saveAnswerRequest(payload));
    }

    // Move to next question
    if (currentQuestionIndex < questionsData.length - 1) {
      const nextIndex = currentQuestionIndex + 1;
      const nextQuestion = questionsData[nextIndex];

      // dispatch(setCurrentQuestionIndex(nextIndex));
      // dispatch(fetchExamQuestionRequest(nextQuestion.qid));

      const nextSection = getSectionKey(nextQuestion);
      const currSection = getSectionKey(currentQuestion);
      if (nextSection !== currSection) {
        dispatch(setActiveSection(nextSection));
      }
    }
  };

  // ✅ Handle Mark for Review
  const handleMarkReview = () => {
    if (currentQuestion) {
      dispatch(
        updateQuestionStatus({
          qid: currentQuestion.qid,
          markReview: true, // mark question for review, do not move or change section
        })
      );
    }
  };

  return (
    <div className="footer-container">
      <div className="footer-left">
        <Button
          title="Previous"
          className="footer-btn outlined-btn"
          onClick={handlePrevious}
          accessor="previous-btn"
        />
        <Button
          title="Mark for Review"
          className="footer-btn outlined-btn"
          onClick={handleMarkReview}
          accessor="review-btn"
        />
      </div>

      <div className="footer-right">
        <Button
          title="Save & Next"
          className="footer-btn contained-error"
          onClick={handleSaveNext}
          accessor="save-next-btn"
        />
      </div>
    </div>
  );
};

export default Footer;
